import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/notifications';

const NewNotification = ({ setNotifications }) => {
    const [notificationType, setNotificationType] = useState('');
    const [notificationText, setNotificationText] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const created_by = 1;
        const newNotification = { notificationType, notificationText, created_by };

        try {
            const response = await api.post('/', newNotification);

            setNotifications(response.data);

            navigate('/notifications');

        } catch (err) {
            console.log("POST FAILED", err);
        }
    };

    return (
        <main className="NewPost">
            <h2>New Notification</h2>
            <form className="newNotificationForm" onSubmit={handleSubmit}>
                <label htmlFor="postTitle">Type:</label>
                <input
                    id="notificationType"
                    type="text"
                    required
                    value={notificationType}
                    onChange={(e) => setNotificationType(e.target.value)}
                />
                <label htmlFor="notificationText">Notification:</label>
                <textarea
                    id="notificationText"
                    required
                    value={notificationText}
                    onChange={(e) => setNotificationText(e.target.value)}
                />
                <button
                    type="submit"
                    onClick={() => console.log("submit button clicked")}
                    >
                    Submit
                    </button>
            </form>
        </main>
    )
}

export default NewNotification;